module.exports = __webpack_public_path__ + "static/websitefm-3afa50bfa63a4ceda8a7c1044d20b50d.jpg";